import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';

var joinUrlPaths = function joinUrlPaths(s) {
  for (var _len = arguments.length, segments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    segments[_key - 1] = arguments[_key];
  }

  return segments.reduce(function (acc, x) {
    return concatPath(acc, x);
  }, s);
};

var concatPath = function concatPath(a, b) {
  return a.endsWith("/") && b.startsWith("/") ? "".concat(a).concat(b.slice(1)) : a.endsWith("/") || b.startsWith("/") ? a + b : "".concat(a, "/").concat(b);
};

var makeQuery = function makeQuery() {
  for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
    keys[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, query = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      query[_key2] = arguments[_key2];
    }

    return keys.map(function (k, i) {
      var v = query[i];
      return Array.isArray(v) ? v.map(encodeValue(k)) : encodeValue(k)(v);
    }).flat().filter(Boolean).join("&");
  };
};

var encodeValue = function encodeValue(k) {
  return function (v) {
    return (v || v === false) && "".concat(k, "=").concat(encodeURIComponent(String(v)));
  };
};

var joinQueries = function joinQueries() {
  for (var _len3 = arguments.length, queries = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    queries[_key3] = arguments[_key3];
  }

  return queries.filter(Boolean).join("&");
};

var toSet = function toSet(source) {
  return _toConsumableArray(new Set(source));
};

var only = function only(a) {
  return Array.isArray(a) ? a[0] : a;
};

var paginationInfo = function paginationInfo(_ref) {
  var from = _ref.from,
      to = _ref.to,
      end = _ref.end,
      perPage = _ref.perPage;
  var page = Math.floor(from / perPage);
  var pageCount = Math.ceil(end / perPage);
  return {
    from: from,
    to: to,
    end: end,
    perPage: perPage,
    page: page,
    pageCount: pageCount,
    next: page < pageCount - 1,
    prev: page > 0
  };
};
var paginationDisplayRange = function paginationDisplayRange(pagination) {
  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  var _ref2 = "page" in pagination ? pagination : paginationInfo(pagination),
      page = _ref2.page,
      pageCount = _ref2.pageCount;

  var startIndex = Math.max(0, page - range);
  var endIndex = Math.min(pageCount - 1, page + range);
  var r = [];
  if (page >= range + 1) r.push(0);
  if (page >= range + 2) r.push("dots");

  for (var i = startIndex; i <= endIndex; i++) {
    r.push(i);
  }

  if (page < pageCount - (range + 2)) r.push("dots");
  if (page < pageCount - (range + 1)) r.push(pageCount - 1);
  return r;
};

/**
 * Tries to emulate the LPS behavior from the backend by selecting property from an object with the current locales of the page
 * @param locales Current page locales
 * @param content Content to filter published locales
 */
var resolveLocale = function resolveLocale(locales, content) {
  return function (resource) {
    var key = content // eslint-disable-next-line @typescript-eslint/no-extra-parens
    ? locales.find(function (l) {
      return typeof content.publishedAt === "string" || !isNil(content.publishedAt) && content.publishedAt[l];
    }) : locales.find(function (l) {
      return !isNil(resource[l]);
    });
    return resource[key];
  };
};

var isNil = function isNil(v) {
  return v === null || v === undefined;
};

var splice = function splice(array, start) {
  var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var r = _toConsumableArray(array);

  for (var _len = arguments.length, replace = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    replace[_key - 3] = arguments[_key];
  }

  r.splice.apply(r, [start, count].concat(replace));
  return r;
};

var traceId = function traceId(a) {
  var _console;

  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  (_console = console).info.apply(_console, [a].concat(rest));

  return a;
};

export { joinQueries, joinUrlPaths, makeQuery, only, paginationDisplayRange, paginationInfo, resolveLocale, splice, toSet, traceId };
//# sourceMappingURL=index.esm.js.map
